import { ItemDetails } from 'components/ItemDetails';
import { ServiceRequests } from 'components/ServiceRequests';
import React from 'react';
import { Map } from 'components/Map';
import { CALENDAR_VIEW } from 'types';
import { QuoteItem } from 'queries/approveOrder/types';
import styled from 'styled-components/macro';
import { useMainProviderContext } from 'context/main/provider';

interface IProps {
  approveQuoteItems: () => Promise<void>;
  handleQuoteItemClick: (updatedQuoteItems: QuoteItem[]) => void;
  quoteItemUpdated: boolean | undefined;
  onChangeView: (view: CALENDAR_VIEW) => void;
}

const AutomotiveItemsWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  > div:first-child {
    margin: 0;
  }
  > div:last-child {
    margin: 0;
  }
  > div {
    border: 1px solid rgb(238, 239, 242);
    border-radius: 6px;
  }

  @media screen and (max-width: 1042px) {
    align-items: center;
  }
`;

// service and sales additional information
export const AutomotiveItems = ({
  quoteItemUpdated,
  handleQuoteItemClick,
  approveQuoteItems,
  onChangeView,
}: IProps) => {
  const { response, isBuilderPreviewMode } = useMainProviderContext();
  const {
    repairOrder,
    inventoryItem,
    mapIframeEmbedCode,
    calendar,
    playerDesign,
    dealerSocketFormLink,
    landingPageDesign,
  } = response || {};
  const quoteItems = repairOrder?.quoteItems || [];
  const mainColor = playerDesign?.playerBackgroundColor;
  const isApproved = repairOrder?.status === 'Responded';

  return (
    <AutomotiveItemsWrapper>
      {quoteItems.length > 0 && (
        <ServiceRequests
          isPreview={isBuilderPreviewMode}
          onSubmit={approveQuoteItems}
          handleQuoteItemClick={handleQuoteItemClick}
          quoteItems={quoteItems}
          isApproved={isApproved}
          mainColor={mainColor}
          quoteItemUpdated={quoteItemUpdated}
        />
      )}
      {inventoryItem && (
        <ItemDetails
          item={inventoryItem}
          isPreview={isBuilderPreviewMode}
          userCalendarPlatform={calendar?.platform}
          calendarWebsiteUrl={calendar?.calendarWebsiteUrl}
          onChangeView={onChangeView}
          mainColor={mainColor}
          dealerSocketFormLink={dealerSocketFormLink}
        />
      )}
      {!!mapIframeEmbedCode && inventoryItem && (
        <Map
          landingPageDesign={landingPageDesign}
          mapIframeEmbedCode={mapIframeEmbedCode}
        />
      )}
    </AutomotiveItemsWrapper>
  );
};
